module.exports = __webpack_public_path__ + "static/media/nour.a6eb4c22.jpg";